import React, { useMemo } from 'react';

import { Badge } from '@mui/material';
import { IconMessageCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DropDownMenu } from '@/components/lists/DropDownMenu';
import { DropDownMenuItem } from '@/components/lists/DropDownMenu/DropDownMenu.types';
import { LOCALE_KEYS, Language } from '@/constants/languages';

import { useLocaleStore } from '../../stores/useLocaleStore';
import { SessionNavAvatar } from './SessionNavAvatar';
import { SessionNavChip } from './SessionNavChip';

export const NavSelectorLanguage = () => {
    const { t, i18n } = useTranslation();
    const { locale: storeLocale, setLocale } = useLocaleStore();

    const title = useMemo(() => t('language'), [t]);

    const items = useMemo(
        (): DropDownMenuItem[] =>
            LOCALE_KEYS.map((locale) => ({
                label: t(locale.toLowerCase() as Language, { ns: 'locales' }),
                id: locale.toLowerCase(),
                action: (itemId) => {
                    if (itemId === storeLocale) return;

                    setLocale(itemId as Language);
                    i18n.language = itemId;
                },
            })),
        [t, i18n, storeLocale, setLocale],
    );

    return (
        <DropDownMenu id="languageselector" title={title} items={items}>
            <Badge
                role="button"
                aria-label={i18n.language.toUpperCase()}
                overlap="circular"
                sx={{ '> .MuiBadge-badge': { pointerEvents: 'none' } }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={<SessionNavChip label={i18n.language.toUpperCase()} />}
            >
                <SessionNavAvatar>
                    <IconMessageCircle size={20} />
                </SessionNavAvatar>
            </Badge>
        </DropDownMenu>
    );
};
